import { styled, Theme } from '@mui/material/styles'
import { getFontWeight, getLineHeight } from '../theme/comprehensive-theme'
interface Props {
  theme?: Theme
}

export const ErrorMessage = styled('p')((props: Props) => {
  const palette = props.theme?.palette
  return {
    '&': {
      color: palette?.red?.main,
      fontWeight: getFontWeight('light'),
      fontSize: '10px', // No matching helper for 10px
      lineHeight: getLineHeight('normal'),
      margin: '0',
      height: '14px',
    },
  }
})
